import { IconProps } from "./types";

export default function USDT0Icon({ width = 40, height = 40 }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 976 976"
      fill="none"
    >
      <circle cx="488.008" cy="488.324" r="487.965" fill="#00B988" />
      <path
        d="M238.48 233.252H737.533V344.152H543.459V455.054H432.557V344.152H238.48V233.252Z"
        fill="white"
      />
      <path
        d="M432.557 455.054V676.856H321.656V455.054H432.557Z"
        fill="white"
      />
      <path
        d="M543.475 676.856H654.36V455.054H543.459V676.856H432.574V787.757H543.475V676.856Z"
        fill="white"
      />
    </svg>
  );
}
